import { render, staticRenderFns } from "./standardadd.vue?vue&type=template&id=7954c073&scoped=true"
import script from "./standardadd.vue?vue&type=script&lang=js"
export * from "./standardadd.vue?vue&type=script&lang=js"
import style0 from "./standardadd.vue?vue&type=style&index=0&id=7954c073&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7954c073",
  null
  
)

export default component.exports